module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("\nMurder on the Cliffs")]), _c('link', {
    attrs: {
      "href": "css/stylesheet.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('link', {
    attrs: {
      "href": "css/page-template.xpgt",
      "rel": "stylesheet",
      "type": "application/adobe-page-template+xml"
    }
  }), _vm._v(" "), _c('meta', {
    attrs: {
      "content": "text/html; charset=utf-8",
      "http-equiv": "content-type"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "tit"
  }, [_vm._v("M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("URDER")])]), _vm._v(" "), _c('p', {
    staticClass: "tit1"
  }, [_c('em', [_vm._v("on the")])]), _vm._v(" "), _c('p', {
    staticClass: "tit2"
  }, [_vm._v("C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("LIFFS")])]), _vm._v(" "), _c('p', {
    staticClass: "stit"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("A DAPHNE du MAURIER MYSTERY")])]), _vm._v(" "), _c('p', {
    staticClass: "au"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("JOANNA CHALLIS")])]), _vm._v(" "), _c('p', {
    staticClass: "img1"
  }, [_c('img', {
    attrs: {
      "alt": "art",
      "src": "images/Art_logo.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pub"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("Minotaur Books")]), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "art",
      "src": "images/Art_tp.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("New York")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6290e5d1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/titlepage.vue
// module id = 60
// module chunks = 0